import ActiveDevices from './ActiveDevices/ActiveDevices'
import NewUsers from './NewUsers/NewUsers'
import NewDevicesCount from './NewDevicesCount'
import DeviceVersionNumbers from './DeviceVersionNumbers/DeviceVersionNumbers'
import NewDevicesCountByMonths from './NewDevicesCountByMonths'
import ActiveDevicesByMonths from './ActiveDevicesByMonths/ActiveDevicesByMonths'

const StatsSA = () => {
  return (
    <section>
      <div>
        <NewUsers></NewUsers>
      </div>
      <section>
        <ActiveDevicesByMonths></ActiveDevicesByMonths>
      </section>
      <section>
        <ActiveDevices></ActiveDevices>
      </section>
      <section>
        <NewDevicesCountByMonths></NewDevicesCountByMonths>
      </section>
      <section>
        <NewDevicesCount></NewDevicesCount>
      </section>
      <section className="m-t-32">
        <DeviceVersionNumbers platform="ios"></DeviceVersionNumbers>
      </section>
      <section className="m-t-32">
        <DeviceVersionNumbers platform="android"></DeviceVersionNumbers>
      </section>
    </section>
  )
}
export default StatsSA